import {handleBrailleTooltip, handleVolume, handleVolumeTooltip} from "./special_control";
import {isMobile} from "./helpers";

if (sessionStorage.getItem('accessability') === '1') {
    specialActivate();
}

$_vikon(() => {
    if (sessionStorage.getItem('accessability') === '1') {
        $_vikon('#vikon-special-menu').show();
        hideMenuHeaderAndFooter();
    }
    $_vikon('body').on('click', '.accessability', function () {
        const body = $_vikon('body');
        const accessability = sessionStorage.getItem('accessability');
        if (accessability === '1') {
            sessionStorage.setItem('accessability', 0);
            specialDeactivate(body);
            showMenuHeaderAndFooter();
        } else {
            sessionStorage.setItem('accessability', 1);
            specialActivate();
            $_vikon('#vikon-special-menu').show();
            hideMenuHeaderAndFooter();
        }
        $_vikon(this).trigger('accessability');
    });
});

function specialActivate() {
    const body = $_vikon('body');
    volumeMobileHandle();
    let isImagesOn = sessionStorage.getItem('is-images-on');
    let specialFontSize = sessionStorage.getItem('special-font-size');
    let specialSiteColor = sessionStorage.getItem('special-site-color');
    let specialFontFamily = sessionStorage.getItem('special-font-family');
    let specialLetterSpacing = sessionStorage.getItem('special-letter-spacing');
    let specialInterval = sessionStorage.getItem('special-interval');
    let isBrailleOn = sessionStorage.getItem('is-braille-on');
    let isVolumeOn = sessionStorage.getItem('is-volume-on');
    if (isImagesOn === null) {
        sessionStorage.setItem('is-images-on', 1);
        isImagesOn = '1';
    }
    if (isVolumeOn === null) {
        sessionStorage.setItem('is-volume-on', 0);
        isVolumeOn = '0';
    }
    if (isBrailleOn === null) {
        sessionStorage.setItem('is-braille-on', 0);
        isBrailleOn = '0';
    }
    if (specialFontSize === null) {
        sessionStorage.setItem('special-font-size', 1);
        specialFontSize = '1';
    }
    if (specialSiteColor === null) {
        sessionStorage.setItem('special-site-color', 1);
        specialSiteColor = '1';
    }
    if (specialFontFamily === null) {
        sessionStorage.setItem('special-font-family', 1);
        specialFontFamily = '1';
    }
    if (specialLetterSpacing === null) {
        sessionStorage.setItem('special-letter-spacing', 1);
        specialLetterSpacing = '1';
    }

    if (specialInterval === null) {
        sessionStorage.setItem('special-interval', 1);
        specialInterval = '1';
    }

    body.addClass('special-version-on');

    createHiddenImgAltInfo();
    createOwlCarouselAltInfo();
    if (isImagesOn === '0') {
        $_vikon('#special-images-off').addClass('special-btn-active');
        $_vikon('#abitur_slider').addClass('hide');
        body.addClass('special-img-off');
        $_vikon('.special-img-info').removeClass('hide');
    } else {
        $_vikon('#special-images-on').addClass('special-btn-active');
        $_vikon('.special-img-info').addClass('hide');
        $_vikon('#abitur_slider').removeClass('hide');
    }

    if (isBrailleOn === '1') {
        body.addClass('special-font-family-braille');
    }

    if (isVolumeOn === '1') {
        $_vikon('#special-volume-logo').removeClass('fa-volume-off');
        $_vikon('#special-volume-logo').addClass('fa-volume');
        body.addClass('special-volume-on');
        body.on('mouseup', handleVolume);
    }

    if (specialFontSize === '1') {
        body.addClass('special-font-size-normal');
        $_vikon('#special-font-size-normal').addClass('special-btn-active');
    } else if (specialFontSize === '2') {
        body.addClass('special-font-size-big');
        $_vikon('#special-font-size-big').addClass('special-btn-active');
    } else if (specialFontSize === '3') {
        body.addClass('special-font-size-large');
        $_vikon('#special-font-size-large').addClass('special-btn-active');
    }

    if (specialSiteColor === '1') {
        body.addClass('special-site-color-black-white');
        $_vikon('#special-site-color-black-white').addClass('special-btn-active');
    } else if (specialSiteColor === '2') {
        body.addClass('special-site-color-white-black');
        $_vikon('#special-site-color-white-black').addClass('special-btn-active');
    } else if (specialSiteColor === '3') {
        body.addClass('special-site-color-darkblue-blue');
        $_vikon('#special-site-color-darkblue-blue').addClass('special-btn-active');
    }

    if (specialFontFamily === '1') {
        body.addClass('special-font-family-arial');
        $_vikon('#special-font-family-arial').addClass('special-btn-active');
    } else if (specialFontFamily === '2') {
        body.addClass('special-font-family-times-new-roman');
        $_vikon('#special-font-family-times-new-roman').addClass('special-btn-active');
    }

    if (specialLetterSpacing === '1') {
        body.addClass('special-letter-spacing-normal');
        $_vikon('#special-letter-spacing-normal').addClass('special-btn-active');
    } else if (specialLetterSpacing === '2') {
        body.addClass('special-letter-spacing-big');
        $_vikon('#special-letter-spacing-big').addClass('special-btn-active');
    } else if (specialLetterSpacing === '3') {
        body.addClass('special-letter-spacing-large');
        $_vikon('#special-letter-spacing-large').addClass('special-btn-active');
    }

    if (specialInterval === '1') {
        body.addClass('special-interval-single');
        $_vikon('#special-interval-single').addClass('special-btn-active');
    } else if (specialInterval === '2') {
        body.addClass('special-interval-one-and-a-half');
        $_vikon('#special-interval-one-and-a-half').addClass('special-btn-active');
    } else if (specialInterval === '3') {
        body.addClass('special-interval-double');
        $_vikon('#special-interval-double').addClass('special-btn-active');
    }
    handleVolumeTooltip();
    handleBrailleTooltip();
}

function specialDeactivate(body) {
    body.removeClass('special-version-on special-font-size-normal special-font-size-big '
        + 'special-font-size-large special-site-color-black-white special-site-color-white-black '
        + 'special-site-color-darkblue-blue special-font-family-arial special-font-family-times-new-roman '
        + 'special-letter-spacing-normal special-letter-spacing-big special-letter-spacing-large special-images-off'
        + 'special-font-family-braille special-interval-single special-interval-one-and-a-half special-interval-double special-volume-on');
    body.off('mouseup', handleVolume);
    $_vikon('#vikon-special-menu').hide();
    $_vikon('body #volume_start').remove();
    removeAltInfo();
    $_vikon('#abitur_slider').removeClass('hide');
}

function hideMenuHeaderAndFooter() {
    $_vikon('#vikon-header, #vikon-footer').hide();
    $_vikon('[itemprop="copy"]').hide();
}

function showMenuHeaderAndFooter() {
    $_vikon('#vikon-header, #vikon-footer').show();
    $_vikon('[itemprop="copy"]').show();
}

function createHiddenImgAltInfo() {
    $_vikon('img:not(.owl-img)').each(function () {
        const isAltDefault = $_vikon(this).attr('alt') === $_vikon(this).attr('src');
        if ($_vikon(this).is('[alt]') && $_vikon(this).attr('alt') && !isAltDefault) {
            $_vikon(this).after(`<p class="special-img-info hide">Изображение: ${$_vikon(this).attr('alt')}</p>`);
        }
    });
}

function createOwlCarouselAltInfo() {
    $_vikon('.owl-carousel').after('<ul class="special-img-info hide" id="alt-owl-carousel"></ul>');
    const elements =
        $_vikon('.owl-item:not(.cloned) .owl-text-overlay').length === 0
            ? $_vikon('.owl-text-overlay')
            : $_vikon('.owl-item:not(.cloned) .owl-text-overlay');
    elements.each(function () {
        const title = $_vikon(this).find('.owl-title').text();
        const caption = $_vikon(this).find('.owl-caption').text();
        $_vikon('#alt-owl-carousel').append(`<li>Изображение: ${title + ' ' + caption}</li>`);
    });
}

function removeAltInfo() {
    $_vikon('.special-img-info').remove();
}

function volumeMobileHandle() {
    const isMobileUser = isMobile.any() !== null;
    if (isMobileUser) {
        $_vikon('#is-volume-on').addClass('hide');
        sessionStorage.setItem('is-volume-on', 0);
    } else {
        $_vikon('#is-volume-on').removeClass('hide');
    }
}
